import "./App.css";
import MyDocument from "./MyDocument";

function App() {
  return <MyDocument />;
}

export default App;
